import React from 'react';
import { HiOutlineTrash } from 'react-icons/hi2';

interface MermasProps {
  mermas: any[];
}

const Mermas: React.FC<MermasProps> = ({ mermas }) => {
  const formatDate = (d?: string) => {
    if (!d) return '';
    const date = new Date(d);
    return new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
  };

  return (
    <div className="mp-table-card">
      <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
        <table className="mp-table">
          <thead className="mp-table-head">
            <tr>
              <th>Fecha</th>
              <th>Almacenamiento</th>
              <th>Cantidad</th>
              <th>Usuario</th>
            </tr>
          </thead>
          <tbody className="mp-table-body">
            {mermas && mermas.length > 0 ? (
              mermas.map((m: any, idx: number) => (
                <tr key={m.merma_id ?? idx}>
                  <td>
                    <div style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-color)' }}>{formatDate(m.local_timestamp || m.timestamp).split(',')[0]}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{formatDate(m.local_timestamp || m.timestamp).split(',')[1]}</div>
                  </td>
                  <td style={{ fontSize: '0.875rem', color: 'var(--text-color)' }}>{m.storage_unit_name || '-'}</td>
                  <td>
                    <span style={{ fontWeight: 700, color: 'var(--text-color)' }}>{m.quantity}</span>{' '}
                    <span style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{m.unidad_medida_acronym || ''}</span>
                  </td>
                  <td style={{ fontSize: '0.875rem', color: 'var(--text-color)' }}>{m.user_name || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ padding: 0, border: 'none' }}>
                  <div className="mp-empty-state">
                    <HiOutlineTrash className="mp-empty-state-icon" />
                    <div className="mp-empty-state-title">Sin mermas registradas</div>
                    <p style={{ fontSize: '0.875rem', color: 'var(--text-color)', opacity: 0.5 }}>No se han registrado mermas para este ingrediente</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {mermas && mermas.length > 0 && (
        <div className="mp-table-footer">
          <span style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{mermas.length} merma{mermas.length !== 1 ? 's' : ''}</span>
        </div>
      )}
    </div>
  );
};

export default Mermas;
